export default __webpack_public_path__ + "static/media/2.7d7b56fd.webm";